<ng-container *ngIf="integrations$ | async"></ng-container>

<div class="wizard-course-code">
  <h5 class="wizard-heading-1">
    Course Code Matches
    <p class="wizard-content">
      The courses that partially match any of the provided values with its
      course code will be imported
    </p>
  </h5>

  <label>Course Code Match - Minimum of 4 characters</label>
  <div class="wizard-course-code-new-input-container">
    <input
      class="wizard-course-code-new-input-codecode"
      nbInput
      placeholder="Course Code"
      [(ngModel)]="newCode"
    />

    <button
      (click)="addNewInput()"
      [disabled]="!selectedIntegration || newCode?.length < 4"
      nbButton
    >
      {{ "add" | translation }}
    </button>
  </div>
  <div class="course-code-container">
    <div class="input" *ngFor="let code of rows; let codeindex = index">
      <div class="input-pill">
        <span class="input-content">{{ code }}</span>
        <button class="input-pill-delete-btn" (click)="removeElement(codeindex)">
          <i class="fa-thin fa-xmark"></i>
        </button>
      </div>
    </div>
  </div>
</div>
